import { createContext } from 'react';

export interface NavigationEntry {
  path: string;
  isReplace: boolean;
}

const NavigationHistoryContext = createContext<NavigationEntry[]>([]);

export default NavigationHistoryContext;
